import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { OrganisationModule } from '../../organization/organisation.module';
import { RegistrationByEdsComponent } from './registration-by-eds/registration-by-eds.component';
import { RegisterOrganizationComponent } from './register-organization/register-organization.component';
import { SharedModule } from '../../../shared/shared.module';
import { RegistrationRoutingModule } from './registration-routing.module';
import { RegistrationBySmsComponent } from './registration-by-sms/registration-by-sms.component';
import { LandingSharedModule } from '../landing-shared/landing-shared.module';
import { RegistrationTopMenuComponent } from './registration-top-menu/registration-top-menu.component';
import { SuccessWindowComponent } from './success-window/success-window.component';
import { RegistrationBySmsFormComponent } from './registration-by-sms/registration-by-sms-form/registration-by-sms-form.component';
import { RegistrationBySmsConfirmPhoneComponent } from './registration-by-sms/registration-by-sms-confirm-phone/registration-by-sms-confirm-phone.component';

@NgModule({
  declarations: [
    RegistrationTopMenuComponent,
    RegistrationByEdsComponent,
    RegistrationBySmsComponent,
    RegisterOrganizationComponent,
    SuccessWindowComponent,
    RegistrationBySmsFormComponent,
    RegistrationBySmsConfirmPhoneComponent,
  ],
  imports: [
    OrganisationModule,
    SharedModule,
    FormsModule,
    LandingSharedModule,
    RegistrationRoutingModule,
    ReactiveFormsModule,
    MatTooltipModule,
  ],
  exports: [],
})
export class RegistrationModule {
}
